/* =====================================================
   SEABROOK LINEN — THEME JS
   Cart logic now talks to Shopify's real Ajax Cart API
   (window.themeRoutes is set in layout/theme.liquid)
===================================================== */

// ---------- MOBILE MENU ----------
function toggleMobileMenu() {
    const menu = document.getElementById("mobileMenu");
    menu.classList.toggle("-translate-x-full");
}

// ---------- SEARCH OVERLAY ----------
function toggleSearch() {
    const overlay = document.getElementById("searchOverlay");
    overlay.classList.toggle("opacity-0");
    overlay.classList.toggle("pointer-events-none");
    if (!overlay.classList.contains("opacity-0")) {
        setTimeout(() => document.getElementById("searchInput")?.focus(), 200);
    }
}

// ---------- ACCOUNT / WISHLIST MODALS ----------
function toggleAccountModal() {
    const modal = document.getElementById("accountModal");
    modal.classList.toggle("opacity-0");
    modal.classList.toggle("pointer-events-none");
}

function toggleWishlistModal() {
    const modal = document.getElementById("wishlistModal");
    modal.classList.toggle("opacity-0");
    modal.classList.toggle("pointer-events-none");
}

// ---------- CART DRAWER ----------
function toggleCartDrawer() {
    const drawer = document.getElementById("cartDrawer");
    drawer.classList.toggle("translate-x-full");
    drawer.classList.toggle("pointer-events-none");
}

// ---------- NOTIFICATION TOAST ----------
function showNotification(message) {
    const alertBox = document.getElementById("customAlert");
    document.getElementById("customAlertText").innerText = message;
    alertBox.classList.remove("translate-y-20", "opacity-0");
    alertBox.classList.add("translate-y-0", "opacity-100");

    clearTimeout(window._notifTimeout);
    window._notifTimeout = setTimeout(() => {
        alertBox.classList.add("translate-y-20", "opacity-0");
        alertBox.classList.remove("translate-y-0", "opacity-100");
    }, 3000);
}

// ---------- ADD TO CART (real Shopify Ajax API) ----------
// variantId: the Shopify variant ID to add, quantity: how many
function addToCart(variantId, quantity, triggerEl) {
    quantity = quantity || 1;

    if (triggerEl) {
        triggerEl.disabled = true;
        triggerEl.dataset.originalText = triggerEl.dataset.originalText || triggerEl.innerText;
        triggerEl.innerText = "Adding...";
    }

    fetch(window.themeRoutes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.status) {
                // Shopify returns an error object with a `status` + `description` on failure
                showNotification(data.description || "Couldn't add that item right now.");
                return;
            }
            const itemName = (data.items && data.items[0] && data.items[0].product_title) || "Item";
            showNotification(`"${itemName}" Added To Your Sanctuary Selection`);
            refreshCartDrawer();
        })
        .catch(() => showNotification("Something went wrong adding that item."))
        .finally(() => {
            if (triggerEl) {
                triggerEl.disabled = false;
                triggerEl.innerText = triggerEl.dataset.originalText;
            }
        });
}

// ---------- CHANGE LINE ITEM QUANTITY (real Shopify Ajax API) ----------
// line: 1-based index of the cart line item, newQuantity: 0 removes it
function changeQuantity(line, newQuantity) {
    fetch(window.themeRoutes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: Math.max(0, newQuantity) })
    })
        .then((res) => res.json())
        .then(() => refreshCartDrawer())
        .catch(() => showNotification("Couldn't update your cart just now."));
}

// ---------- REFRESH CART DRAWER MARKUP + BADGE ----------
// Re-renders the cart drawer section via Shopify's Section Rendering API so
// quantities/prices/line items stay in sync with the real cart, without a full page reload.
function refreshCartDrawer() {
    fetch(`${window.themeRoutes.cartPage}?section_id=cart-drawer`)
        .then((res) => res.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newDrawer = doc.getElementById("cartDrawer");
            const currentDrawer = document.getElementById("cartDrawer");
            if (newDrawer && currentDrawer) {
                // preserve open/closed state classes
                const wasOpen = !currentDrawer.classList.contains("translate-x-full");
                currentDrawer.innerHTML = newDrawer.innerHTML;
                if (wasOpen) {
                    currentDrawer.classList.remove("translate-x-full", "pointer-events-none");
                }
            }
        })
        .finally(updateCartBadgeFromApi);
}

// Fallback / simplest path: just pull cart.js for the item count badge
function updateCartBadgeFromApi() {
    fetch(window.themeRoutes.cart)
        .then((res) => res.json())
        .then((cart) => {
            const badge = document.getElementById("cartCountBadge");
            if (badge) badge.innerText = cart.item_count;
        });
}

// ---------- CHECKOUT ----------
function mockCheckout() {
    window.location.href = `${window.themeRoutes.cartPage}/checkout`;
}

// ---------- QUICK VIEW MODAL ----------
// Reads product data from the clicked card's data-* attributes (rendered by
// snippets/product-card.liquid) instead of a hardcoded JS product database.
function triggerQuickView(triggerEl) {
    const card = document.querySelector(triggerEl.dataset.cardSelector) || triggerEl.closest(".product-card");
    if (!card) return;

    const name = card.dataset.productTitle;
    const price = parseFloat(card.dataset.productPrice);
    const image = card.dataset.productImage;
    const desc = card.dataset.productDescription;
    const variantId = card.dataset.variantId;

    document.getElementById("qvProductImage").src = image;
    document.getElementById("qvProductName").innerText = name;
    document.getElementById("qvProductPrice").innerText = formatMoney(price);
    document.getElementById("qvProductDesc").innerText = desc;

    const addBtn = document.getElementById("qvAddToCartBtn");
    addBtn.onclick = () => {
        addToCart(variantId, 1, addBtn);
        closeQuickView();
    };

    const modal = document.getElementById("quickViewModal");
    modal.classList.remove("opacity-0", "pointer-events-none");
    modal.classList.add("opacity-100", "pointer-events-auto");
}

function closeQuickView() {
    const modal = document.getElementById("quickViewModal");
    modal.classList.add("opacity-0", "pointer-events-none");
    modal.classList.remove("opacity-100", "pointer-events-auto");
}

// Basic money formatter fallback (cart drawer / product cards use Liquid's `money` filter directly;
// this is only used for values built client-side, like the quick view panel)
function formatMoney(amountInDollars) {
    return `$${amountInDollars.toFixed(2)}`;
}

// ---------- BESTSELLERS CAROUSEL ----------
function scrollBestsellers(direction) {
    const wrapper = document.getElementById("bestsellersWrapper");
    if (!wrapper) return;
    const scrollAmount = 350;

    if (direction === 1 && wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 10) {
        wrapper.scrollTo({ left: 0, behavior: "smooth" });
    } else if (direction === -1 && wrapper.scrollLeft <= 10) {
        wrapper.scrollTo({ left: wrapper.scrollWidth, behavior: "smooth" });
    } else {
        wrapper.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
    }
}

let bestsellersAutoScroll;
function startBestsellersAutoScroll() {
    clearInterval(bestsellersAutoScroll);
    bestsellersAutoScroll = setInterval(() => scrollBestsellers(1), 3000);
}

// ---------- CATEGORY FILTER (smooth scroll only; real filtering = link to a collection) ----------
function filterCategory(categoryName) {
    showNotification(`Filtering boutique choices for: ${categoryName}`);
    document.getElementById("bestsellers")?.scrollIntoView({ behavior: "smooth" });
}

// ---------- REVIEWS CAROUSEL ----------
let activeReviewIndex = 0;
function setReviewActive(index) {
    const reviewSlides = document.querySelectorAll(".review-slide");
    const reviewDots = document.querySelectorAll("#reviewDots span");
    activeReviewIndex = index;

    reviewSlides.forEach((slide, idx) => slide.classList.toggle("hidden", idx !== index));
    reviewDots.forEach((dot, idx) => {
        dot.classList.toggle("bg-gold", idx === index);
        dot.classList.toggle("bg-navy/20", idx !== index);
    });
}

function navigateReview(direction) {
    const reviewSlides = document.querySelectorAll(".review-slide");
    if (!reviewSlides.length) return;
    let nextIndex = activeReviewIndex + direction;
    if (nextIndex < 0) nextIndex = reviewSlides.length - 1;
    if (nextIndex >= reviewSlides.length) nextIndex = 0;
    setReviewActive(nextIndex);
}

// ---------- INIT ----------
document.addEventListener("DOMContentLoaded", () => {
    // Scroll reveal animation
    const revealElements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) entry.target.classList.add("active");
            });
        },
        { threshold: 0.1 }
    );
    revealElements.forEach((el) => observer.observe(el));

    startBestsellersAutoScroll();
    updateCartBadgeFromApi();
});
